export default function AboutSection() {
  return (
    <section className="relative w-full py-24 md:py-36 px-6 md:px-10 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
          <div className="lg:w-1/3">
            <span className="inline-block text-xs font-medium text-foreground-400 uppercase tracking-widest mb-6">
              / Why Hipobuy Sheet
            </span>
            <div className="flex items-center gap-3 mt-8">
              <span className="inline-block w-2 h-2 rounded-full bg-accent-500"></span>
              <span className="text-xs text-foreground-400 font-medium">Updated Weekly</span>
            </div>
          </div>

          <div className="lg:w-2/3">
            <h2 className="font-heading text-3xl md:text-5xl font-light text-foreground-800 leading-snug mb-10">
              A Hipobuy spreadsheet organizes thousands of curated product finds into one easy-to-navigate resource — saving shoppers hours of manual searching across scattered storefronts.
            </h2>

            <p className="text-foreground-600 text-base leading-relaxed mb-6 max-w-2xl">
              Whether you are hunting for the latest sneaker drops, browsing streetwear collections, or comparing accessory prices, a well-structured Hipobuy spreadsheet puts everything at your fingertips. Each entry is hand-picked and verified, complete with direct links, size availability, and pricing details — so you spend less time searching and more time discovering products you actually want.
            </p>

            <p className="text-foreground-600 text-base leading-relaxed mb-6 max-w-2xl">
              Our guides cover everything from beginner tutorials to advanced comparison strategies. We break down how different spreadsheet platforms work, highlight the best categories to explore, and share insider tips that experienced shoppers use to score the best deals. No fluff, no affiliate bias — just honest, practical information designed to make your shopping experience smoother and smarter.
            </p>

            <div className="flex flex-wrap items-center gap-2 mt-10">
              <div className="flex -space-x-2">
                {[1, 2, 3, 4].map((i) => (
                  <div
                    key={i}
                    className={`w-12 h-12 rounded-full border-2 border-background-50 flex items-center justify-center text-xs font-bold text-foreground-700 ${
                      ['bg-accent-100', 'bg-primary-100', 'bg-secondary-200', 'bg-accent-200'][i - 1]
                    }`}
                  >
                    {['MC', 'SM', 'JO', 'ER'][i - 1]}
                  </div>
                ))}
              </div>
              <span className="text-sm text-foreground-500 font-medium ml-3">
                Join 10,000+ smart shoppers using our sheets
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}